module.exports = __webpack_public_path__ + "assets/img/Agency.dd8816b0.png";